import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { GroupedAggregationOverTimeResponse } from '../types/Incidents';
import { httpGet } from '../../../../components/utils';

interface Params {
    diffInDays: number;
    aggregationField: string;
    refreshToken?: number;
}

const useGetIncidentsAggregationOverTime = ({ aggregationField, diffInDays, refreshToken }: Params) => {
    const [data, setData] = useState<GroupedAggregationOverTimeResponse>();
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    useEffect(() => {
        const fetchIncidentsSeverityOverview = async () => {
            setIsFetching(true);
            setError(undefined);

            try {
                const response = (await httpGet('/incidents/aggregation', {
                    [HTTP_OPTIONS.REQ_OPTIONS]: {
                        params: {
                            diffInDays,
                            aggregationField
                        }
                    }
                })) as unknown as AxiosResponse<GroupedAggregationOverTimeResponse>;

                setData(response.data);
            } catch (err) {
                setError(
                    `Failed to get incidents aggregation over time from servers, params: aggregation field: ${aggregationField}, diffInDays: ${diffInDays}`
                );
            }
            setIsFetching(false);
        };

        fetchIncidentsSeverityOverview();
    }, [aggregationField, diffInDays, refreshToken]);

    return { data, isFetching, error };
};

export default useGetIncidentsAggregationOverTime;
